import { renderClassName } from "@/utils/renderClassName";

type ContainerProps = {
  element?: "ul";
  className?: string;
  children: React.ReactNode;
};

const Container = ({ element, className, children }: ContainerProps) => {
  const Element = element || "div";

  return (
    <Element className={renderClassName("container", className)}>
      {children}
    </Element>
  );
};

export default Container;
